<div class="solution-tag solution-tag-{{localTagType[tagType].toLowerCase()}}" [ngStyle]="{'font-size':textSize}">
    {{localTagType[tagType]}}
</div>